import { render } from "./MusicList.vue?vue&type=template&id=32166a00&scoped=true"
import script from "./MusicList.vue?vue&type=script&lang=js"
export * from "./MusicList.vue?vue&type=script&lang=js"

import "./MusicList.vue?vue&type=style&index=0&id=32166a00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32166a00"]])

export default __exports__